import { useHudStore } from "../store/hudStore";
import { passkeyEnrolled } from "../lib/prefs";
import { canPasskey } from "../lib/config";
import { Badge, Button, Card } from "../design-system/components";
import Page from "../components/Page";

// Account settings: passkey enrolment and sign out (moved here off the top bar).
export default function Settings() {
  const st = useHudStore();
  const supported = canPasskey();
  const enrolled = passkeyEnrolled(st.email);

  return (
    <Page back="Back to the HUD">
      <Card className="detail-hero">
        <span className="detail-identity-icon"><i aria-hidden="true" className="fa-solid fa-gear" /></span>
        <div className="detail-head-body"><h1 className="detail-heading detail-title">Settings</h1><p className="detail-copy">Signed in as <b>{st.email || "None"}</b></p></div>
      </Card>
      <Card className="detail-stack" title={<span className="detail-icon-title"><i aria-hidden="true" className="fa-solid fa-fingerprint" />Passkey</span>} description="Sign in with your fingerprint, face, or device PIN instead of a password.">
        {!supported ? <p className="detail-copy">This browser doesn't support passkeys.</p> : enrolled ? (
          <Badge tone="success" className="settings-status"><i aria-hidden="true" className="fa-solid fa-circle-check" />Passkey active on this device</Badge>
        ) : <Button className="settings-passkey-action" variant="primary" onClick={st.setupPasskey} loading={st.pkBusy} icon="fa-solid fa-plus">{st.pkBusy ? "Setting up…" : "Add a passkey"}</Button>}
        {st.pkMsg && <Badge role={st.pkTone === "ok" ? "status" : "alert"} tone={st.pkTone === "ok" ? "success" : "danger"} className="settings-status"><i aria-hidden="true" className={st.pkTone === "ok" ? "fa-solid fa-circle-check" : "fa-solid fa-circle-exclamation"} />{st.pkMsg}</Badge>}
      </Card>
      <Card className="settings-session" title={<span className="detail-icon-title"><i aria-hidden="true" className="fa-solid fa-user" />Session</span>} actions={<Button variant="danger" onClick={st.signOut} icon="fa-solid fa-arrow-right-from-bracket">Sign out</Button>} />
    </Page>
  );
}
